
import { computed, defineComponent, watch } from 'vue'
import AppHeader from '@/components/common/App/AppHeader.vue'
import { useStore } from 'vuex'
import useWeb3 from '@/services/web3/useWeb3'
import useRefreshApi from './composables/useRefreshApi'

export default defineComponent({
  components: { AppHeader },
  setup() {
    const store = useStore()
    const { blockNumber } = useWeb3()
    const isAuth = computed(() => store.getters['auth/isAuth'])

    if (isAuth.value) {
      useRefreshApi()
    }

    watch(blockNumber, () => {
      if (isAuth.value) {
        store.dispatch('swap/fetchTokens')
        store.dispatch('swap/fetchAllowancesAndBalances')
      }
    })

    console.log('Hello, 1inch!🐴')
  }
})
